import { __decorate, __metadata } from "tslib";
import { appendStyle } from '@1inch-community/core/lit-utils';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let LoaderSkeletonElement = class LoaderSkeletonElement extends LitElement {
    constructor() {
        super(...arguments);
        this.animationDelayMillisecond = 0;
    }
    static { this.tagName = 'inch-loader-skeleton'; }
    static { this.styles = css `
    :host {
      display: block;
      cursor: wait;
      width: 6em;
      background: linear-gradient(
        90deg,
        var(--color-background-bg-secondary) 25%,
        var(--color-background-bg-primary) 37%,
        var(--color-background-bg-secondary) 63%
      );
      background-size: 400% 100%;
      animation: pulse 5s linear infinite;
      border-radius: 4px;
    }

    @keyframes pulse {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `; }
    render() {
        appendStyle(this, {
            animationDelay: `${this.animationDelayMillisecond}ms`,
        });
        return html `<slot>&nbsp;</slot>`;
    }
};
__decorate([
    property({ type: Number, attribute: false }),
    __metadata("design:type", Number)
], LoaderSkeletonElement.prototype, "animationDelayMillisecond", void 0);
LoaderSkeletonElement = __decorate([
    customElement(LoaderSkeletonElement.tagName)
], LoaderSkeletonElement);
export { LoaderSkeletonElement };
//# sourceMappingURL=loader-skeleton.element.js.map